import { atom } from "jotai";

import { VideoResolution, ScreenShareMode } from "@/types/stream";

export const guestNameAtom = atom<string>(
  localStorage.getItem("@Guest/name") ?? "",
);

export const serverHostAtom = atom<string>(
  localStorage.getItem("@Guest/serverHost") ?? "",
);

export const serverPortAtom = atom<string>(
  localStorage.getItem("@Guest/serverPort") ?? "",
);

const detectLanguage = (): string => {
  const stored = localStorage.getItem("user-language");

  if (stored && ["en", "es", "pt"].includes(stored)) return stored;

  const sys = (navigator.language || "en").split("-")[0];

  return ["en", "es", "pt"].includes(sys) ? sys : "en";
};

export const languageAtom = atom<string>(detectLanguage());

// Camera preferences

export const cameraResolutionAtom = atom<VideoResolution>(
  (localStorage.getItem("@Guest/cameraResolution") as VideoResolution) ||
    VideoResolution.HD720,
);

export const cameraFpsAtom = atom<number>(
  Number(localStorage.getItem("@Guest/cameraFps")) || 30,
);

export const cameraMirrorAtom = atom<boolean>(
  localStorage.getItem("@Guest/cameraMirror") === "true",
);

// Screen share preferences

export const screenShareModeAtom = atom<ScreenShareMode>(
  (localStorage.getItem("@Guest/screenShareMode") as ScreenShareMode) ||
    ScreenShareMode.FullScreen,
);

export const screenResolutionAtom = atom<VideoResolution>(
  (localStorage.getItem("@Guest/screenResolution") as VideoResolution) ||
    VideoResolution.HD720,
);

export const screenFpsAtom = atom<number>(
  Number(localStorage.getItem("@Guest/screenFps")) || 30,
);

export const screenIncludeMicAtom = atom<boolean>(
  localStorage.getItem("@Guest/screenIncludeMic") === "true",
);

export const screenIncludeSystemAudioAtom = atom<boolean>(
  localStorage.getItem("@Guest/screenIncludeSystemAudio") === "true",
);
